import ApiClient from './axios-wrapper';
import { BankBrasilAPIRes } from './brasilAPI.types';

const api = new ApiClient({
  baseURL: 'https://brasilapi.com.br/api/',
  withCredentials: false,
});

class BrasilAPIService {
  async getBankByCode(bankCode: string) {
    return await api.get<BankBrasilAPIRes>(`banks/v1/${bankCode}`);
  }

  async getAllBanks() {
    return await api.get<BankBrasilAPIRes[]>('banks/v1');
  }
}
export const brasilAPIService = new BrasilAPIService();

/* 
https://brasilapi.com.br/docs
 */
